import { cashRegisterApi } from "../../api";

const CashRegisterService = {

    /**
     * 📋 Obtener todas las terminales POS
     * GET /api/cash/registers
     */
    getAll: async () => {
        const response = await cashRegisterApi.fetchAll();
        return response.data;
    },

    /**
     * 🔽 Obtener terminales POS para dropdown
     * GET /api/cash/registers/dropdown
     */
    dropdown: async () => {
        const response = await cashRegisterApi.fetchCustom("/dropdown");
        return response.data;
    },

    /**
     * 🔎 Obtener una terminal POS por ID
     * GET /api/cash/registers/{id}
     */
    getById: async (id: number) => {
        const response = await cashRegisterApi.fetchById(id);
        return response.data;
    },

    /**
     * ➕ Crear una terminal POS
     * POST /api/cash/registers
     */
    create: async (data: any) => {
        const response = await cashRegisterApi.add(data);
        return response.data;
    },

    /**
     * ✏️ Actualizar una terminal POS
     * PUT /api/cash/registers/{id}
     */
    update: async (id: number, data: any) => {
        const response = await cashRegisterApi.modifyCustom(`/${id}`, data);
        return response.data;
    },

    /**
     * 🚫 Desactivar terminal POS
     * PATCH /api/cash/registers/{id}/deactivate
     */
    deactivate: async (id: number) => {
        const response = await cashRegisterApi.patchCustom(`${id}/deactivate`);
        return response.data;
    }

};

export default CashRegisterService;